import { userConstants } from '../constants';

export function initAuthRequest(username, password) {
    console.log('Action Received the auth request ' + username);
    return {
            type: userConstants.LOGIN_REQUEST,
            payload: {
                username: username,
                password: password
            }
    };
}

export function initRegistrationRequest(formData) {
    console.log('Action Received the form data');
    return {
        type: userConstants.REGISTER_REQUEST,
        payload: {
            formData: formData
        }
    }
}

export function resetPasswordRequest(username) {
    console.log('Action Received the data: ' + username);
    return {
        type: userConstants.RESET_PASSWORD_REQUEST,
        payload: {
            email : username
        }
    }
}

export function initChangePasswordRequest(formData) {
    console.log('Action Received the form data: ' + formData);
    return {
        type: userConstants.CHANGE_PASSWORD_REQUEST,
        payload: {
            username: formData.email,
            password: formData.password,
            resetCode: formData.resetCode
        }
    }
}

export function getAllDownloadsRequest() {
    return {
        type: userConstants.GETALL_REQUEST
    }
}
  